export default __webpack_public_path__ + "static/media/Alert_Yellow.e670429f.png";